module.exports = __webpack_public_path__ + "static/job-sync-ac440625f32a9fa319a36488d78335b7.jpg";